module.exports = __webpack_public_path__ + "assets/img/Root100_2018_desktop-2c7ae5179fede17748d6c682d1363a10.jpg";


//////////////////
// WEBPACK FOOTER
// ./theroot/root-100-2019/src/img/Root100_2018_desktop.jpg
// module id = 208
// module chunks = 0